/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceModel } from '../../models/health-care-service-model';

export interface HealthFindrHealthCareServiceFhirIdGet$Params {
  fhirId: string;
}

export function healthFindrHealthCareServiceFhirIdGet(http: HttpClient, rootUrl: string, params: HealthFindrHealthCareServiceFhirIdGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<HealthCareServiceModel>> {
  const rb = new RequestBuilder(rootUrl, healthFindrHealthCareServiceFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<HealthCareServiceModel>;
    })
  );
}

healthFindrHealthCareServiceFhirIdGet.PATH = '/HealthFindr/HealthCareService/{fhirId}';
